// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { HTMLDivProps, Tab, TabId, Tabs, Text } from "@blueprintjs/core";

import { GeoMap } from "src/controllers/alerts/components";

import { Classes, MPDIcon } from "src/mpd-library";

import "./styles.css";

export interface IRightSideProps extends HTMLDivProps {
  previewSend: any;
  mapTopStyle?: number;
}

interface IRightSideState {
  tabId: TabId;
}

export class RightSide extends React.Component<
  IRightSideProps,
  IRightSideState
> {
  public constructor(props: IRightSideProps) {
    super(props);
    this.onTabChanged = this.onTabChanged.bind(this);

    this.state = {
      tabId: 0
    };
  }

  public render() {
    const { className, previewSend, mapTopStyle } = this.props;
    const { tabId } = this.state;
    const classes = classNames("right-side", className);

    return (
      <div className={classes}>
        <Tabs
          id={"preview-send-tabs"}
          onChange={this.onTabChanged}
          selectedTabId={tabId}
        >
          <Tab
            className={classNames(tabId === 1 && 'previous-tab')}
            id={0}
            title="Push"
            panel={
              <div className="compose-alert-preview-container">
                <div className="header">
                  <div className="compose-login-logo">
                    <MPDIcon name="compose-login-logo" />
                    <Text className="text"> SPOT </Text>
                  </div>
                  <Text className="text"> Now </Text>
                </div>
                <Text className="sub-heading">{previewSend.headline}</Text>
                <Text className="description">{previewSend.description}</Text>
              </div>
            }
          />
          <Tab
            className={classNames(tabId === 0 && 'next-tab')}
            id={1}
            title="Full Details"
            panel={
              <div className="compose-alert-preview-details" onScroll={e => e.stopPropagation()}>
                <div
                  className="full-details-map-container"
                  style={{ top: mapTopStyle ? mapTopStyle : undefined }}
                >
                  {(previewSend.incidentLocation.status ||
                    previewSend.geoFence.status) && (
                    <GeoMap
                      style={{ height: `100%` }}
                      hideControls={true}
                      center={
                        previewSend.incidentLocation.center ||
                        previewSend.geoFence.currentShape.center
                      }
                      currentShape={
                        previewSend.geoFence ? (
                          previewSend.geoFence.currentShape
                        ) : (
                          undefined
                        )
                      }
                      currentMarker={previewSend.incidentLocation.marker}
                    />
                  )}
                </div>
                <div className="wrapper">
                  <div className="inner-container">
                    <div className="header">
                      <Text
                        className={classNames(
                          "severity",
                          Classes.severitiesClass(previewSend.severity)
                        )}
                      >
                        {previewSend.severity}
                      </Text>
                      <Text className="headline"> {previewSend.headline} </Text>
                      <Text className="date"> {previewSend.date} </Text>
                      <Text className="expiration">
                        Expires In {previewSend.expiration}
                      </Text>
                    </div>
                    <div className="content">
                      {previewSend.thumbnails && (
                        <div className="thumbnails-container">
                          {previewSend.thumbnails.map(
                            (thumbnail: any, index: number) => (
                              <div className="thumbnail" key={index}>
                                <img src={thumbnail} />
                              </div>
                            )
                          )}
                        </div>
                      )}
                      <Text className="description">
                        {previewSend.description}
                      </Text>
                      {previewSend.files.map((element: any, index: number) => (
                        <div className="files-placeholder-container">
                          <MPDIcon
                            name="fil-audio"
                            className={classNames(
                              "left-icon",
                              element.id === "audio" && Classes.ACTIVE
                            )}
                          />
                          <MPDIcon
                            name="fil-movie"
                            className={classNames(
                              "left-icon",
                              element.id === "video" && Classes.ACTIVE
                            )}
                          />
                          <MPDIcon
                            name="fil-attach"
                            className={classNames(
                              "left-icon",
                              element.id === "document" && Classes.ACTIVE
                            )}
                          />
                          <Text className="name"> {element.name} </Text>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            }
          />
        </Tabs>
      </div>
    );
  }
  private onTabChanged(
    newTabId: TabId,
    prevTabId: TabId,
    event: React.MouseEvent<HTMLElement>
  ) {
    this.setState({ tabId: newTabId });
  }
}



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/preview-send/right-side.tsx